import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useGymProfessors } from "@/hooks/useGymProfessors";

interface InstructorSelectorProps {
  value: string;
  onChange: (value: string) => void;
  gymId?: string;
  userRole?: string;
}

export const InstructorSelector = ({ value, onChange, gymId, userRole }: InstructorSelectorProps) => {
  const { data: professors, isLoading } = useGymProfessors(gymId);
  
  // Managers see a dropdown, professors see text input
  if (userRole === 'manager') {
    return (
      <div className="space-y-2">
        <Label htmlFor="instructor" className="text-sm font-medium text-white/90">
          Instructor <span className="text-red-400">*</span>
        </Label>
        
        {/* Hidden input for native HTML validation */}
        <input
          type="text"
          value={value}
          onChange={() => {}} // Controlled by Select
          required
          className="sr-only"
          tabIndex={-1}
          aria-hidden="true"
        />
        
        <Select value={value} onValueChange={onChange}>
          <SelectTrigger className={`border-white/20 bg-black/30 text-white ${!value ? 'border-red-400/50' : ''}`}>
            <SelectValue placeholder="Seleccionar instructor *" />
          </SelectTrigger>
          <SelectContent className="bg-background border-white/20">
            {isLoading ? (
              <SelectItem value="loading" disabled>Cargando...</SelectItem>
            ) : professors?.length === 0 ? (
              <SelectItem value="none" disabled>No hay profesores disponibles</SelectItem>
            ) : (
              professors?.map(prof => (
                <SelectItem key={prof.id} value={prof.full_name}>
                  {prof.full_name}
                </SelectItem>
              ))
            )}
          </SelectContent>
        </Select>
        
        {!value && (
          <p className="text-xs text-red-400">Selecciona un instructor</p>
        )}
      </div>
    );
  }
  
  // Default text input for professors
  return (
    <div className="space-y-2">
      <Label htmlFor="instructor" className="text-sm font-medium text-white/90">
        Instructor
      </Label>
      <Input
        id="instructor"
        placeholder="Ejemplo: Rita Denevi"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required
        className="border-white/20 bg-black/30 text-white"
      />
    </div>
  );
};
